import m, {MithrilComponent, type Children} from '@bitstillery/mithril'
import {classes} from '@bitstillery/common/lib/utils'

import type {CmsComponentMeta} from '@bitstillery/common/cms/catalog_meta'

export const quoteCardMeta = {
    tier: 'content',
    summary: 'Short callout card: light surface, teal left accent, optional decorative quote mark.',
    when_to_use: 'Team intros, pull quotes, CMS callouts. Not a `HeroBand` — no full-bleed background.',
    example: `
    <QuoteCard>
        <Paragraph>Discover halved the time we spend sourcing stock.</Paragraph>
    </QuoteCard>
    `,
    variants: [
        {
            prop: 'show_quote_mark',
            jsx: `
            <QuoteCard show_quote_mark>
                <Paragraph>Discover halved the time we spend sourcing stock.</Paragraph>
            </QuoteCard>
            `,
        },
    ],
} satisfies CmsComponentMeta

export interface QuoteCardAttrs {
    /** Main body (typically a paragraph). Prefer JSX children; may be set on attrs for programmatic use. */
    children?: Children
    className?: string
    /** Decorative quotation mark in the corner (hidden on very narrow viewports in CSS). */
    show_quote_mark?: boolean
}

/**
 * Short callout block: light surface, teal left accent, optional decorative quote mark.
 * Reusable for team intros, quotes, and CMS marketing copy.
 */
export class QuoteCard extends MithrilComponent<QuoteCardAttrs> {
    view(vnode: m.Vnode<QuoteCardAttrs>) {
        const {children: attrsChildren, className, show_quote_mark = true} = vnode.attrs
        /** Mithril passes JSX children on `vnode.children`, not `attrs.children`. */
        const body = vnode.children ?? attrsChildren
        return (
            <div className={classes('quote-card', show_quote_mark && 'quote-card--with-mark', className)} role='note'>
                {body}
            </div>
        )
    }
}
